<div class="float-right d-none d-sm-block text-bold">
  <span>Design & Developed by</span>
  <a
    href="http://cktechsoln.in/"
    class="text-dark"
    target="_blank"
    rel="noopener noreferrer"
    style="margin: 0"
  > CKTech Solution Pvt Ltd, Madurai</a
  >
  <span>.</span>
</div>
<strong>
  <span>Copyrights &copy; {{ currentYear }}</span>
  <!-- <a
    href="http://lf.cktechsoln.in/"
    target="_blank"
    rel="noopener noreferrer"
    style="margin: 0"
    class="text-dark"
  >
    Lovely Fashion</a
  >
  <span>.</span>
</strong>
<span> All rights reserved.</span> -->
